import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate
} from "react-router-dom";

import Header from "./Components/Header";
import Home from "./pages/Home";
import About from "./Components/About";
import Services from "./Components/Services";
import Doctor from "./Components/Doctor";
import Blogs from "./Components/Blogs";
import Faqs from "./Components/Faqs";
import Contact from "./Components/Contact";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Department from "./pages/Department";
import Appointment from "./pages/Appointment";
import MyBooking from "./pages/MyBooking";
import Dashboard from "./admin/Dashboard";
import Footer from "./Components/Footer";
import Gallery from "./pages/Gallery";
import FloatingIcons from "./Components/FloatingIcons";

// A wrapper to access useLocation inside the Router
const MainApp = () => {

  const navigate = useNavigate();

  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";
  const isHome = location.pathname === "/";

  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");

  const ProtectedRoute = ({ children }) => {
    if (!token) {
      return navigate('/login');
    }

    if (user && user.isAdmin !== 1) {
      return navigate('/');
    }

    return children;
  };

  return (
    <>
      {!isDashboard && !isHome && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/doctors" element={<Doctor />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />

        {/* Pages */}
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/department" element={<Department />} />
        <Route path="/appointment/:id" element={<Appointment />} />
        <Route path="/my-booking" element={<MyBooking />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      {!isDashboard && <Footer />}
      {!isDashboard && <FloatingIcons />}
    </>
  );
};

function App() {
  return (
    <Router>
      <MainApp />
    </Router>
  );
}

export default App;
